import { Button, Input, Modal } from "antd";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
`;

export const Message = styled.span`
  color: rgba(49, 65, 88, 1);
  font-size: 16px;
  font-weight: 400;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14;
  line-height: 100%;
  letter-spacing: 0%;
  margin-right: 10px;
  @media (max-width: 930px) {
    font-size: 12px;
    padding: 4px 8px;
  }
  @media (max-width: 570px) {
    display: none;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.button`
  background-color: ${({ active }) =>
    active ? "rgba(6, 142, 195, 1)" : "rgba(241, 245, 249, 1)"};
  border: none;
  width: 42px;
  height: 32px;
  border-radius: 10px;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  &:hover {
    transform: scale(1.05);
  }

  svg {
    font-size: 18px;
    color: ${({ active }) =>
      active ? "rgba(255, 255, 255, 1)" : "rgba(194, 194, 204, 1)"};
  }
`;

export const ModalWithdrawalAndDisassociate = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    padding: 5px;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-content {
    padding: 24px;
  }

  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-footer {
    padding: 0;
    margin-top: 24px;
    border-top: none;
  }

  @media (max-width: 600px), (max-height: 500px) {
    width: 90% !important;
    max-width: 90% !important;

    .ant-modal-content {
      max-height: 90vh;
      display: flex;
      flex-direction: column;
    }

    .ant-modal-body {
      overflow-y: auto;
      max-height: 60vh; /* ajuste conforme a altura que você precisa */
    }
  }
`;

export const ButtonFormConfirm = styled(Button)`
  font-family: "Inter", sans-serif;
  border-radius: 10px;
  border: none;
  height: 38px;
  width: 109px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  &:disabled {
    background-color: #d3d3d3 !important;
    color: #a1a1a1 !important;
    border: none !important;
    cursor: not-allowed;
  }
  margin-top: 0;
`;

export const ButtonProtocol = styled(Button)`
  font-family: "Inter", sans-serif;
  border-radius: 10px;
  border: none;
  height: 38px;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
`;

export const HeaderModal = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    background: #f9f9fd;
  }
`;
export const ModalTitle = styled.div`
  max-width: 658px;
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  color: #314158;
  text-transform: capitalize;
`;
export const CredentialsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
`;
export const CredentialsListLabel = styled.div`
  border-radius: 10px;
  border: 1px solid rgba(226, 232, 240, 1);
  font-weight: 500;
  font-size: 16px;
  font-family: "Inter";
  padding: 5px;
  padding-left: 15px;
  color: rgba(98, 116, 142, 1);
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 150%;
  letter-spacing: 0px;
`;

export const ModalSubTitle = styled.span`
  font-family: "Inter";
  font-weight: 400;
  font-size: 16px;
  line-height: 10%;
  color: rgba(98, 116, 142, 1);
`;
export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;

  span.steps {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #62748e;
  }
`;
export const HeaderModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;
export const StyledInput = styled(Input)`
  border-radius: 10px;
  width: 100%;
  height: 48px !important;
  padding-inline: 8px;
  border: 1px solid rgba(223, 223, 224, 1);
  box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  &::placeholder {
    color: rgba(104, 104, 110, 1);
  }
`;

export const FormLabel = styled.label`
  font-family: "Inter" sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;
  color: rgba(49, 65, 88, 1);
`;

export const SuccessModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
  .ant-modal-content {
    border-radius: 10px;
    padding: 5px;
  }
  .ant-modal-header {
    border-bottom: none; /* Remove o divisor do rodapé */
  }

  .ant-modal-body{
    padding-bottom: 0;
  }

  .ant-modal-footer {
    border-top: none; /* Remove o divisor do rodapé */
  }
`;

export const LaterWithdrawContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const StyledSpan = styled.span`
  margin-bottom: 8px;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;
  color: rgba(49, 65, 88, 1);
`;
